// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "." + chunkId + "." + "f454586b3133fb5c2241" + ".chunk.js";
};